export function formatarCpf(doc: string): string {
  const alfanumerico = doc.replace(/[^a-zA-Z0-9]/g, "");

  // Formata conforme a quantidade de caracteres
  let formatado = alfanumerico;
  if (alfanumerico.length <= 3) {
    formatado = alfanumerico;
  } else if (alfanumerico.length <= 6) {
    formatado = alfanumerico.replace(/(.{3})(.{0,3})/, "$1.$2");
  } else if (alfanumerico.length <= 9) {
    formatado = alfanumerico.replace(/(.{3})(.{3})(.{0,3})/, "$1.$2.$3");
  } else if (alfanumerico.length <= 11) {
    formatado = alfanumerico.replace(/(.{3})(.{3})(.{3})(.{0,2})/, "$1.$2.$3-$4");
  }

  return formatado;
}

export function formatarCnpj(doc: string): string {
  const alfanumerico = doc.replace(/[^a-zA-Z0-9]/g, "");

  // Formata conforme a quantidade de caracteres
  let formatado = alfanumerico;
  if (alfanumerico.length <= 2) {
    formatado = alfanumerico;
  } else if (alfanumerico.length <= 5) {
    formatado = alfanumerico.replace(/(.{2})(.{0,3})/, "$1.$2");
  } else if (alfanumerico.length <= 8) {
    formatado = alfanumerico.replace(/(.{2})(.{3})(.{0,3})/, "$1.$2.$3");
  } else if (alfanumerico.length <= 12) {
    formatado = alfanumerico.replace(/({.2})(.{3})(.{3})(.{0,4})/, "$1.$2.$3/$4");
  } else if (alfanumerico.length <= 14) {
    formatado = alfanumerico.replace(/(.{2})(.{3})(.{3})(.{4})(.{0,2})/, "$1.$2.$3/$4-$5");
  }

  return formatado;
}

export function MaskDocument(value: string) {
  let documentoMascarado = "";

  if (value.replace(/[^a-zA-Z0-9]/g, "").length <= 11) {
    documentoMascarado = formatarCpf(value)
  }
  else {
    documentoMascarado = formatarCnpj(value)
  }

  return documentoMascarado
}